import { DataDisputeItemStatus } from 'src/api';

export const DATA_DISPUTE_STATUS_LABEL: Record<DataDisputeItemStatus, string> = {
  [DataDisputeItemStatus.InProgress]: 'In Progress',
  [DataDisputeItemStatus.Resolved]: 'Resolved',
};
